export default defineNuxtRouteMiddleware(async () => {
  if (process.server) return;

  if (window.localStorage.getItem("saveUrl")) {
    const url = window.localStorage.getItem("saveUrl");
    window.localStorage.removeItem("saveUrl");
    return navigateTo(url);
  }

  const baseStore = useBaseStore();
  const userStore = useUserStore();
  const authStore = useAuthStore();

  await baseStore.getUserMe()
    .then(async (res) => {
      let userData = res;
      authStore.$patch({ user: userData })
      baseStore.$patch({ isAuthenticated: true })
      userData.userType = await baseStore.getUserType(userData.userType);
      userStore.$patch({ type: userData.userType, position: userData.userRole })
    })
    .catch((e) => {
      return navigateTo('/');
    });
});
